import React from 'react';
import PropTypes from 'prop-types';
import { Form, ListGroupItem, Row, Col, Button } from 'react-bootstrap';
import { map, cloneDeep, isEmpty } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import {
  getFeatureSelectedWeight,
  getFeatureSelectedColor
} from '../../../api/Users/user-operations';
import * as layerOps from '../../../api/Layers/layer-operations';

import { isMaps } from '../../../modules/checkDeployEnv';
import { featureGetZoom } from '../../../modules/geojson-utilities';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import ColorPicker from '../ColorPicker';
import ModalMap from '../../atoms/ModalMap';

class MapsProfileSettings extends React.Component {
  state = {
    isShownMap: false
  };

  hideMap = () => this.setState({ isShownMap: false });

  showMap = () => this.setState({ isShownMap: true });

  updateUserControls = async (variable, newValue) => {
    const { userControlSetting } = this.props;
    const updatedSetting = {
      ...userControlSetting,
      [variable]: newValue,
      value: false
    };
    try {
      const method =
        updatedSetting.value === true ? 'admin.addUserControl' : 'admin.updateUserControl';
      await methodPromise(method, updatedSetting);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  updateDefaultBaseMap = async event => {
    const { profile } = this.props;
    const newProfile = cloneDeep(profile);
    newProfile.profile.defaultBaseMap = event.target.value.trim();
    try {
      await methodPromise('users.editProfile', newProfile);
      Bert.alert('Profile updated!', 'success');
    } catch (error) {
      console.error(error);
      handleErrorInClient(error);
    }
  };

  updateFeatureSelectedColor = async newBackgroundMapColor => {
    const { profile } = this.props;
    const newProfile = cloneDeep(profile);
    newProfile.profile.featureSelectedColor = newBackgroundMapColor.hex;
    try {
      await methodPromise('users.editProfile', newProfile);
      Bert.alert('Profile updated!', 'success');
    } catch (error) {
      console.error(error);
      handleErrorInClient(error);
    }
  };

  updateFeatureSelectedWeight = async event => {
    const { profile } = this.props;
    const newProfile = cloneDeep(profile);
    newProfile.profile.featureSelectedWeight = Number(event.target.value.trim());
    try {
      await methodPromise('users.editProfile', newProfile);
      Bert.alert('Profile updated!', 'success');
    } catch (error) {
      console.error(error);
      handleErrorInClient(error);
    }
  };

  render() {
    const { deployEnv, layerList, profile, userControlSetting } = this.props;
    const { isShownMap } = this.state;
    const [lng, lat] =
      userControlSetting &&
      !isEmpty(userControlSetting) &&
      userControlSetting.defaultMapCenter &&
      userControlSetting.defaultMapCenter.geometry &&
      userControlSetting.defaultMapCenter.geometry.coordinates
        ? userControlSetting.defaultMapCenter.geometry.coordinates
        : [0, 0];

    const zoom = featureGetZoom(userControlSetting.defaultMapCenter);
    if (isEmpty(profile) && !isMaps(deployEnv)) return '';
    return (
      <>
        <ListGroupItem>
          <Form.Group as={Row}>
            <Form.Label column sm={6}>
              Layers default base map
            </Form.Label>
            <Col sm={6}>
              <Form.Control
                as="select"
                name="defaultBaseMap"
                defaultValue={
                  userControlSetting.defaultBaseMap && !isEmpty(userControlSetting.defaultBaseMap)
                    ? userControlSetting.defaultBaseMap
                    : '-'
                }
                onChange={event =>
                  this.updateUserControls('defaultBaseMap', event.target.value.trim())
                }
              >
                <option value="">-- No user defined base map --</option>
                {map(layerList, layer => {
                  return (
                    <option value={layerOps.getId(layer)} key={layerOps.getId(layer)}>
                      {layerOps.getName(layer)}
                    </option>
                  );
                })}
              </Form.Control>
            </Col>
          </Form.Group>
        </ListGroupItem>
        <ListGroupItem>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group as={Row}>
                <Form.Label column xs={8}>
                  Selected Feature Color
                </Form.Label>
                <Col xs={4}>
                  <ColorPicker
                    color={getFeatureSelectedColor(profile)}
                    alpha={1}
                    updateColor={this.updateFeatureSelectedColor}
                    disableAlpha
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group as={Row}>
                <Form.Label column xs={8}>
                  Selected Feature Weight
                </Form.Label>
                <Col xs={4}>
                  <Form.Control
                    defaultValue={getFeatureSelectedWeight(profile)}
                    onBlur={this.updateFeatureSelectedWeight}
                    type="number"
                    name="selectedFeatureWeight"
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </ListGroupItem>
        <ListGroupItem>
          <Form.Group as={Row}>
            <Form.Label column sm={6} style={{ lineHeight: 'calc(4.5em + 2.25rem - 8px)' }}>
              Default Map Center
            </Form.Label>
            <Col sm={4}>
              <Row>
                <Form.Label column sm={5}>
                  Longitude
                </Form.Label>
                <Col sm={7}>
                  <Form.Control
                    type="number"
                    name="defaultLongitude"
                    value={lng}
                    onChange={() => {}}
                    readOnly
                  />
                </Col>
                <Form.Label column sm={5}>
                  Latitude
                </Form.Label>
                <Col sm={7}>
                  <Form.Control
                    type="number"
                    name="defaultLatitude"
                    value={lat}
                    onChange={() => {}}
                    readOnly
                  />
                </Col>
                <Form.Label column sm={5}>
                  Zoom
                </Form.Label>
                <Col sm={7}>
                  <Form.Control type="number" name="defaultZoom" value={zoom} step="1" readOnly />
                </Col>
              </Row>
            </Col>
            <Col sm={2}>
              <Button
                block
                style={{ marginTop: 'calc(1.5em + 0.75rem + 2px)' }}
                onClick={this.showMap}
              >
                Select
              </Button>
            </Col>
          </Form.Group>
        </ListGroupItem>
        <ModalMap
          defaultMapCenter={userControlSetting.defaultMapCenter}
          deployEnv={deployEnv}
          headerText="Select Default Center"
          isShownMap={isShownMap}
          hideMap={this.hideMap}
          updateDefaultCenter={this.updateUserControls}
        />
      </>
    );
  }
}
MapsProfileSettings.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  layerList: PropTypes.array.isRequired,
  profile: PropTypes.object.isRequired,
  userControlSetting: PropTypes.object.isRequired
};
export default MapsProfileSettings;
